export default {
  sections: {
    alcohol_percentage: 'Teneur en alcool : {{value}}%',
    price_per_unit: 'Prix par {{unit}} : {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingrédients',
    allergens: 'Allergènes',
    additives: 'Additifs',
    nutrition_breakdown: {
      title: 'Informations nutritionnelles',
      description: '100 {{unit}} contiennent :',
      items: {
        energy: 'Énergie',
        fat: 'Matières grasses',
        saturates: 'dont acides gras saturés',
        carbohydrates: 'Glucides',
        sugars: 'dont sucres',
        protein: 'Protéines',
        salt: 'Sel',
      },
    },
  },
  units: {
    l: 'litre',
    kg: 'kilo',
    default: 'unité',
  },
};
